import React, { Component } from 'react';
import { connect } from 'react-redux';
import VariantChooser from './Components/VariantChooser';
import { load } from '../Actions/VariantChooser.action';

class VariantChooserContainer extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // This method is automatically triggering when component is loaded
        // we use it to call the load-action to init loading variants.
        this.props.load();
    }
    componentWillReceiveProps(newProp) {
        this.props = newProp; 
    }
    render() {
        // Render the component
        return <VariantChooser {...this.props} />
    }
}

const mapStateToProps = state => { 
    return {
        variants: state.variantChooser.variants
    }
}
const mapDispatchToProps = dispatch => {
    return {
        load: () => dispatch(load()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VariantChooserContainer);
